/* eslint-disable */
import Cookie from "./cookie";

export default class Legacy {
  init($) {
    window.isValidEmail = (str) => {
      // are regular expressions supported?
      var supported = 0;
      if (window.RegExp) {
        var tempStr = "a";
        var tempReg = new RegExp(tempStr);
        if (tempReg.test(tempStr)) supported = 1;
      }
      if (!supported)
        return (str.indexOf(".") > 2) && (str.indexOf("@") > 0);
      var r1 = new RegExp("(@.*@)|(\\.\\.)|(@\\.)|(^\\.)");
      var r2 = new RegExp("^.+\\@(\\[?)[a-zA-Z0-9\\-\\.]+\\.([a-zA-Z]{2,6}|[0-9]{1,6})(\\]?)$");
      return (!r1.test(str) && r2.test(str));
    };

    window.submitIt = () => {
      var form = document.formenquiry;
      var first_name = form.first_name.value.trim();
      var last_name = form.last_name.value.trim();
      var phone = form.phone.value.trim();
      var email = form.email.value.trim();
      var postcode = typeof(form.postcode !== 'undefined') && form.postcode != null ? form.postcode.value.trim() : "";
      var message = form.message.value.trim();

      if (first_name.length < 2) {
        alert("Please type in your first name.")
        form.first_name.focus();
      }
      else if (last_name.length < 2) {
        alert("Please type in your last name.")
        form.last_name.focus();
      }
      else if (phone.length < 2) {
        alert("Please type in your phone number.")
        form.phone.focus();
      }
      else if (typeof(form.postcode !== 'undefined') && form.postcode != null && form.postcode.value == "") {
        alert("Please type in your postcode.")
        form.postcode.focus();
      }
      else if (typeof(form.state !== 'undefined') && form.state != null && form.state.value == "") {
        alert("Please select the state where you live.")
        form.state.focus();
      }
      else if (form.country && form.country.selectedIndex <= 0) {
        alert("Please select the country where you live.")
        form.country.focus();
      }
      else if (form.study_preference && form.study_preference.selectedIndex <= 0) {
        alert("Please select your study preference.")
        form.study_preference.focus();
      }
      else if (form.interest_area && form.interest_area.selectedIndex <= 0) {
        alert("Please select your area of interest.")
        form.interest_area.focus();
      }
      else if (form.preferred_study_mode && form.preferred_study_mode.selectedIndex <= 0) {
        alert("Please select your preferred study mode.")
        form.preferred_study_mode.focus();
      }
      else if (form.preferred_contact_time && form.preferred_contact_time.selectedIndex <= 0) {
        alert("Please select your preferred contact time.")
        form.preferred_contact_time.focus();
      }
      else if (email.length < 2) {
        alert("Please type in your email address.")
        form.email.focus();
      }
      else if (!isValidEmail(email)) {
        alert("Please enter an valid Email address.");
        form.email.focus();
      }
      else if (message.length < 8) {
        alert("To be able to provide you with better service, please provide us more information about your request. (Minimum 8 characters)");
        form.message.focus();
      }
      else {
        form.submit();
      }
    };

    $('#select_message_templates').change(function () {
      VTK_Message_Template.updateMessage();
    });

    const lastSearch = window.last_search || null;

    if (lastSearch) {
      // I've converted all instances of the l_search cookie to a JSON object so we set the cookie at the end.
      let searchCookie = new Cookie('l_search');

      for (const [key, value] of Object.entries(lastSearch)) {
        searchCookie[key] = value;
      }

      searchCookie.store(2,'years', '/');
    }

    // Now deal with referrer cookie
    String.prototype.getHostname = function () {
      let re = new RegExp('^(?:f|ht)tp(?:s)?\://([^/]+)', 'im');
      re = this.match(re);
      return re && re.length ? re[1].toString() : '';
    };

    let referring_url = "";
    let referrer_host = "";

    if (document.referrer) {
      referring_url = document.referrer;
    }


    if (referring_url) {
      referrer_host = referring_url.getHostname();
      referrer_host = referrer_host.toLowerCase();
    }

    if (referrer_host !== window.location.hostname) {
      // Create the cookie we'll use to save state for this web page.
      let first_referrer = new Cookie("f_ref"); //first referrer
      let recent_referrer = new Cookie("mr_ref"); //most recent referrer
      const landing_url = window.location.href;
      const current_time = (new Date()).getTime();
      const refresh_interval = 5 * 60; // 5 minutes;

      if (first_referrer.date_time && (parseInt(current_time) - parseInt(first_referrer.date_time)) <= refresh_interval && first_referrer.ref_url == referring_url && first_referrer.ld_url == landing_url) {
        //alert('first referrer refresh!');
      }
      else if (recent_referrer.date_time && (parseInt(current_time) - parseInt(recent_referrer.date_time)) <= refresh_interval && recent_referrer.ref_url == referring_url && recent_referrer.ld_url == landing_url) {
        //alert('most recent referrer refresh!');
      }
      else if (!first_referrer.date_time) {
        if (recent_referrer.date_time) {
          first_referrer.ref_url = recent_referrer.ref_url;
          first_referrer.ld_url = recent_referrer.ld_url;
          first_referrer.date_time = recent_referrer.date_time;
          recent_referrer.remove();

          if (referring_url != recent_referrer.ref_url) {
            recent_referrer.ref_url = referring_url;
            recent_referrer.ld_url = landing_url;
            recent_referrer.date_time = "currentTime";
            recent_referrer.store(2, 'years', '/');
          }
        }
        else {
          first_referrer.ref_url = referring_url;
          first_referrer.ld_url = landing_url;
          first_referrer.date_time = "currentTime";
        }
        first_referrer.store(2, 'years', '/');
      }
      else {

        recent_referrer.ref_url = referring_url;
        recent_referrer.ld_url = landing_url;
        recent_referrer.date_time = "currentTime";
        recent_referrer.store(2, 'years', '/');
      }
    }

    window.submitEnquiryForm = () => {
      const form = document.getElementById('supportForm');

      if (!validatePage()) {
        return false;
      }
      if (!form.Agree.checked) {
        alert('You must accept the terms and conditions');
        form.Agree.focus();
        return false;
      }

      const first_referrer = new Cookie('f_ref');
      const recent_referrer = new Cookie('mr_ref');

      document.getElementById('00N2w000008uAb5').value = first_referrer.ref_url;
      document.getElementById('00N2w000008uAbF').value = getDomainName(first_referrer.ref_url);
      document.getElementById('00N2w000008uAb0').value = recent_referrer.ref_url;
      document.getElementById('00N2w000008uAYp').value = getDomainName(recent_referrer.ref_url);

      form.submit();
    };
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/legacy.js